import { MaterialIcon } from '@gorila-shared-ui/components';
import { memo } from 'react';
import { Marker } from 'react-map-gl/mapbox';
import { useRecoilValue } from 'recoil';
import { VEHICLE_TYPE_CAR } from '../../../constants/vehicle';
import { useCamera } from '../../../hooks/useCamera';
import useUpdateEffect from '../../../hooks/useUpdateEffect';
import { linkDetailLngLatsState, linkDetailState, selectedLinkIdState } from '../../../storage/links';
import VehicleIcon from './VehicleIcon';

function LinkMarkers() {
  const selectedLinkId = useRecoilValue(selectedLinkIdState);
  const linkDetail = useRecoilValue(linkDetailState(selectedLinkId ?? ''));
  const lngLats = useRecoilValue(linkDetailLngLatsState(selectedLinkId ?? ''));
  const { fitToLngLats } = useCamera();

  useUpdateEffect(() => {
    if (!lngLats.length) return;

    fitToLngLats(lngLats);
  }, [lngLats, fitToLngLats]);

  if (!linkDetail) return null;

  const { assetPrimary, assetSecondary } = linkDetail;

  return (
    <>
      <Marker
        latitude={assetPrimary.position_latitude}
        longitude={assetPrimary.position_longitude}
      >
        <MaterialIcon
          name="phone_iphone"
          // color={secondaryDevice.color}
        />
      </Marker>
      <Marker
        latitude={assetSecondary.position_latitude}
        longitude={assetSecondary.position_longitude}
      >
        <VehicleIcon vehicleType={VEHICLE_TYPE_CAR} />
      </Marker>
    </>
  );
}

export default memo(LinkMarkers);
